module.exports = __webpack_public_path__ + "1006d9ffe627e6adf8e26baf095cb537.pdf";